import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getRolesCollection, RolesCollection, SecurityRolesParams } from "@tKgpco/Services/SecurityRolesService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type Parameters = SecurityRolesParams & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, RolesCollection>;

export const BeginLoadSecurityRoles: HandlerType = props => {
    props.dispatch({ type: "Custom/SecurityRoles/BeginLoad" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getRolesCollection(props.parameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteLoadSecurityRoles: HandlerType = props => {
    props.dispatch({
        type: "Custom/SecurityRoles/CompleteLoad",
        roles: props.apiResult,
    });
};

export const chain = [BeginLoadSecurityRoles, RequestDataFromApi, CompleteLoadSecurityRoles];

const searchFilterSecurityRoles = createHandlerChainRunner(chain, "SearchFilterSecurityRoles");
export default searchFilterSecurityRoles;
